import React, { useState } from 'react';
import { X, Send, Mail, CheckCircle, FileText } from 'lucide-react';
import './PlaquetteModal.css';

// Regex pour valider un email
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function PlaquetteModal({ isOpen, onClose }) {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateEmail = (value) => {
    if (!value) {
      setEmailError('Email requis');
      return false;
    }
    if (!EMAIL_REGEX.test(value)) {
      setEmailError('Email invalide');
      return false;
    }
    setEmailError('');
    return true;
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    if (emailError) {
      validateEmail(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateEmail(email)) {
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000';
      
      await fetch(`${backendUrl}/demo-leads/procumatcher`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          email, 
          message: 'Demande de plaquette PDF',
          source: 'landing-plaquette' 
        }),
      });
      
      // Déclencher le téléchargement du PDF
      const link = document.createElement('a');
      link.href = '/documents/plaquette-procumatcher.pdf';
      link.download = 'ProcuMatcher-Plaquette.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      setIsSubmitted(true);
    } catch (error) {
      console.error('Erreur envoi:', error);
      // Télécharger quand même en cas d'erreur
      const link = document.createElement('a');
      link.href = '/documents/plaquette-procumatcher.pdf';
      link.download = 'ProcuMatcher-Plaquette.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      setIsSubmitted(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setEmail('');
    setEmailError('');
    setIsSubmitted(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="plaquette-modal-overlay" onClick={handleClose}>
      <div className="plaquette-modal" onClick={(e) => e.stopPropagation()}>
        <button className="plaquette-modal__close" onClick={handleClose}>
          <X size={18} />
        </button>

        {isSubmitted ? (
          <div className="plaquette-modal__success">
            <div className="plaquette-modal__success-icon">
              <CheckCircle size={32} />
            </div>
            <h3>Téléchargement lancé !</h3>
            <p>La plaquette ProcuMatcher est en cours de téléchargement.</p>
            <button className="plaquette-modal__btn" onClick={handleClose}>
              Fermer
            </button>
          </div>
        ) : (
          <>
            <div className="plaquette-modal__header">
              <div className="plaquette-modal__icon">
                <FileText size={24} />
              </div>
              <h3>Télécharger la plaquette</h3>
              <p>Entrez votre email pour télécharger notre plaquette</p>
            </div>
            
            <form onSubmit={handleSubmit} className="plaquette-modal__form">
              <div className="plaquette-modal__field">
                <div className={`plaquette-modal__input-wrapper ${emailError ? 'plaquette-modal__input-wrapper--error' : ''}`}>
                  <Mail size={18} />
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={handleEmailChange}
                    onBlur={() => validateEmail(email)}
                    placeholder="Votre email professionnel"
                    autoFocus
                  />
                </div>
                {emailError && <span className="plaquette-modal__error">{emailError}</span>}
              </div>

              <button
                type="submit"
                disabled={isSubmitting || !email || !!emailError}
                className="plaquette-modal__submit"
              >
                {isSubmitting ? (
                  <>
                    <span className="plaquette-modal__spinner" />
                    Envoi...
                  </>
                ) : (
                <>
                  <Send size={18} />
                  Télécharger
                </>
                )}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default PlaquetteModal;

